import type { RoutingDto } from '../../api/models/RoutingDto';
import { RoutingControllerService } from '../../api/services/RoutingControllerService';

export type RoutingWithId = RoutingDto & { id: number };

/** The slice of RoutingControllerService the routings page needs to persist a routing. */
export interface RoutingPersistenceApi {
  create(requestBody: RoutingDto): PromiseLike<RoutingDto>;
  update(uuid: string, requestBody: RoutingDto): PromiseLike<RoutingDto>;
}

/**
 * Saves a routing and lets every backend error reach the caller.
 *
 * The page used to swallow a 400 as "the save might have succeeded": the dialog closed, the
 * list reloaded and showed the old values, and the user never learned that the routing could
 * not be saved. Exactly the errors the editor provokes are 400s (foreign key violation with
 * input quantities, duplicate operation names, second default routing). Now the error
 * propagates, the CRUD page shows it and keeps the dialog open (review round 5, finding 1.2).
 */
export async function persistRouting(
  dataToSave: RoutingDto,
  id: number,
  api: RoutingPersistenceApi = RoutingControllerService,
): Promise<RoutingWithId> {
  const saved = dataToSave.uuid
    ? await api.update(dataToSave.uuid, dataToSave)
    : await api.create(dataToSave);
  return { ...saved, id } as RoutingWithId;
}
